import type * as registerWin32Icons20px from './registerWin32Icons20px';
import type { Win32Icon20pxProps } from '../components/Win32Icon20px/Win32Icon20px';
import { createLazyComponent, LazyAction, type LazyComponent, LazyModule } from 'owa-bundling';

const lazyModule20px: LazyModule<typeof registerWin32Icons20px> = new LazyModule(
    () => import(/* webpackChunkName: "Win32Icons20px" */ './registerWin32Icons20px'),
    { name: 'Win32Icons20px' }
);

export const lazyRegisterWin32Icons20px: LazyAction<
    typeof registerWin32Icons20px.registerWin32Icons20px,
    typeof lazyModule20px
> = new LazyAction(lazyModule20px, module => module.registerWin32Icons20px);

export const Win32Icon20px: LazyComponent<Win32Icon20pxProps, unknown, void> = createLazyComponent(
    lazyModule20px,
    module => module.Win32Icon20px
);
